export default "__VITE_ASSET__CY52SiTN__"